import React, { useState } from "react";
import PropTypes from "prop-types";
import { BsChevronRight } from "react-icons/bs";

import { cn } from "../../../helpers/utils/css-utils";

const Accordion = ({
  title,
  subtitle,
  initial = false,
  children,
  notifyElement = null,
}) => {
  const [isOpen, setIsOpen] = useState(initial);

  const toggleCollapsible = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div
      className={cn(
        "my-4 overflow-hidden rounded-xl border bg-white shadow-sm transition-all duration-200",
        isOpen
          ? "border-gray-300 shadow-md"
          : "border-gray-200 hover:border-gray-300"
      )}
    >
      <button
        type="button"
        aria-expanded={isOpen}
        className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-gray-50/70 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/20"
        onClick={toggleCollapsible}
      >
        <div className="min-w-0">
          <div className="mb-0.5 flex items-center gap-3">
            <h2 className="text-base font-semibold tracking-tight text-gray-900">
              {title}
            </h2>
            {notifyElement && notifyElement}
          </div>
          {subtitle && (
            <p className="text-sm text-gray-500">
              {subtitle}
            </p>
          )}
        </div>
        <BsChevronRight
          className={cn(
            "h-4 w-4 shrink-0 text-gray-400 transition-transform duration-200",
            {
              "rotate-90": isOpen,
            }
          )}
        />
      </button>
      {isOpen && (
        <div className="border-t border-gray-100 px-5 py-5">
          {children}
        </div>
      )}
    </div>
  );
};

export default Accordion;

Accordion.propTypes = {
  initial: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.any,
  notifyElement: PropTypes.element,
};
